export default __webpack_public_path__ + "static/media/daughter.067e3cb0.svg";